import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LayoutLogin from "../components/layout/LayoutLogin.jsx";
import RedirectFooter from "../components/forms/RedirectFooter.jsx";
import InputForm from "../components/forms/InputForm.jsx";
import AlertInfo from "../components/forms/AlertInfo.jsx";
import AlertError from "../components/forms/AlertError.jsx";
import ButtonSubmit from "../components/forms/ButtonSubmit.jsx";
import ButtonGoogle from "../components/forms/ButoonGoogle.jsx";
import AuthService from "../services/auth.service";
import ProteinViewer from "../components/ProteinViewer.jsx";
import dockerService from "../services/docker.service";
import { gapi } from "gapi-script";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [loading, setLoading] = useState(false);
  const [serverLoading, setServerLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      const url = new URL(window.location.href);
      const redirect = url.searchParams.get("redirect");
      if (redirect) {
        navigate("/?redirect=" + redirect);
      } else {
        navigate("/");
      }
      window.location.reload();
    }
  }, []);

  // useEffect(() => {
  //   function start() {
  //     gapi.auth2.init({
  //       client_id:
  //         "612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com",
  //     });
  //   }
  //   gapi.load("client:auth2", start);
  // }, []);

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await AuthService.signup(email, password, name, linkedIn).then(
        async () => {
          handleResponse();
        },
        (error) => {
          handleFailure(error.response.data.errors[0].msg);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleResponse = async () => {
    setError(false);
    setServerLoading(true);
    setServerMessage("You Logged in successfully, Redirecting ...");
    const url = new URL(window.location.href);
    const redirect = url.searchParams.get("redirect");
    if (redirect) {
      navigate("/?redirect=" + redirect);
    } else {
      navigate("/");
    }
    window.location.reload();
  };

  const handleFailure = (error = null) => {
    setGoogleLoading(false);
    setLoading(false);
    setError(true);
    // setErrorMessage(
    //   error || "Sorry! something bad happened. please try later."
    // );
  };

  return (
    <LayoutLogin>
      <div className="transition-all ease-linear duration-150 bg-black">
        {/* <ProteinViewer /> */}
        <h1 className="font-bold text-4xl text-white mb-2">Sign Up</h1>
        <form
          className="flex flex-col justify-center items-center py-4"
          onSubmit={handleSignup}
        >
          <InputForm title="Name" setValue={setName} />
          <InputForm title="Email" setValue={setEmail} />
          <InputForm title="Linkedin" setValue={setLinkedIn} />
          <InputForm title="Password" setValue={setPassword} />

          <AlertInfo loading={serverLoading} message={serverMessage} />
          <div className="transition-all ease-linear duration-150 flex flex-col w-full mt-2 items-center justify-center">
            <AlertError loading={error} message={errorMessage} />
            <ButtonSubmit text="Sign Up" loading={loading} />
            <ButtonGoogle
              loading={googleLoading}
              setLoading={setGoogleLoading}
              handleResponse={handleResponse}
              handleFailure={handleFailure}
            />

            <RedirectFooter to={"signin"} />
          </div>
        </form>
      </div>
    </LayoutLogin>
  );
};

export default Signup;
